// src/utils/preloadImages.ts
export function preloadImages(urls: string[]) {
  urls.forEach((url) => {
    const img = new window.Image();
    img.src = url;
  });
}
